import styled from "styled-components";

export default styled.p`
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
`;
